export default class Dependente {

    constructor(cpf='', dataNascimento='', id=null, nome='', sexo='') {
        this.cpf = cpf;
        this.dataNascimento = dataNascimento;
        this.id = id;
        this.nome = nome;
        this.sexo = sexo;
    }
}


// WEBPACK FOOTER //
// ./src/domain/dependencia/dependente.js